import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import { Card, FormControlLabel, Switch } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';

import { callAxios, formatError, lpad } from '../../../components/utils/FormatData';
import BasicTab from '../../../components/form/BasicTab';
import GraphDateSelector from '../../../components/form/MonthSelector';
import KeyValue from '../../../components/form/KeyValue';
import TabPanel from '../../../components/layout/TabPanel';
import { URL_API } from '../../../constants/settings';
import axios from 'axios';
import { useAlert } from 'react-alert';

const OngletAlarme = (props) => {
  const alert = useAlert();
  const { width, value, equipment, classes, etats, auth } = props;
  const [graphDatas, setGraphDatas] = useState([]);
  const [displayMode, setDisplayMode] = useState('month');
  const [graphDate, setGraphDate] = useState(moment().startOf('month'));
  const borneMin = moment().subtract(1, 'y').startOf('month');
  const borneMax = moment().endOf('month');
  const [dateFromGraph, setDateFromGraph] = useState();
  const [filterAlarmes, setFilterAlarmes] = useState([]);

  useEffect(() => {
    if (etats && etats.length > 0) {
      transformDatasForGraph();
    }
  }, [graphDate, etats]);
  useEffect(() => {
    if (etats && etats.length > 0) {
      transformDatasForGraph();
    }
  }, [displayMode]);

  useEffect(() => {
    if (dateFromGraph) {
      fetchAlarmesEquipement(dateFromGraph);
    } else {
      setFilterAlarmes([]);
    }
  }, [dateFromGraph]);

  const fetchAlarmesEquipement = (date) => {
    axios({ method: 'get', url: URL_API + '/equipements/' + equipment.id + '/alarmes', params: { jour: date.format('YYYY-MM-DD') } })
      .then(function (res) {
        setFilterAlarmes(res.data);
      })
      .catch(function (err) {
        formatError(alert, err);
      });
  };

  const handlePreviousMonth = () => {
    const previousMonth = moment(Object.assign({}, graphDate)).subtract(1, displayMode === 'year' ? 'y' : 'M');

    if (displayMode === 'month' && previousMonth.isBetween(borneMin, borneMax, 'd', '[]')) {
      setGraphDate(previousMonth);
      setDateFromGraph(null);
    }
    if (displayMode === 'year' && previousMonth.isSame(borneMin, 'y')) {
      setGraphDate(previousMonth);
      setDateFromGraph(null);
    }
  };
  const handleNextMonth = () => {
    const nextMonth = moment(Object.assign({}, graphDate)).add(1, displayMode === 'year' ? 'y' : 'M');

    if (displayMode === 'month' && nextMonth.isBetween(borneMin, borneMax, 'd', '[]')) {
      setGraphDate(nextMonth);
      setDateFromGraph(null);
    }
    if (displayMode === 'year' && nextMonth.isSame(borneMax, 'y')) {
      setGraphDate(nextMonth);
      setDateFromGraph(null);
    }

  };
  const transformDatasForGraph = () => {
    let transformedDatas;

    if (displayMode === 'year') {
      transformedDatas = statesByYear(etats, moment(Object.assign({}, graphDate)).startOf('year'), moment(Object.assign({}, graphDate)).endOf('year'));
    } else {
      transformedDatas = statesByMonth(etats, graphDate, moment(Object.assign({}, graphDate)).endOf('month'));
    }

    setGraphDatas(transformedDatas);
  };
  const statesByMonth = (datas, start, end) => {
    const statesByMonth = [];
    const monthBoundary = { start: false, end: false };
    let globalState = [];

    // Récupération des états bornes et des valeurs du mois en cours
    for (let i = 0; i < datas.length; i++) {
      if (!moment(datas[i].dateEtat).isBefore(start) && monthBoundary.start === false) {
        datas[i - 1] ? statesByMonth.push(datas[i - 1]) : null;
        monthBoundary.start = true;
      }
      if (moment(datas[i].dateEtat).isBetween(start, end, 's', '[]')) {
        statesByMonth.push(datas[i]);
      }
      if (moment(datas[i].dateEtat).isAfter(end) && monthBoundary.end === false) {
        statesByMonth.push(datas[i]);
        monthBoundary.end = true;
      }
    }

    // Génération des proportions pour l'ensemble des jours du mois
    if (statesByMonth && statesByMonth.length > 0) {
      let lastState = statesByMonth[0].etat;
      for (let i = 0; i < graphDate.daysInMonth(); i++) {
        const dayDate = moment(`${start.format('MM')}-${lpad(i + 1, '0', 2)}-${start.format('YYYY')}`, 'MM-DD-YYYY');

        // Création des valeurs du graphe pour la journée donnée si elle se trouve sur l'interval
        if (dayDate.isBetween(moment().subtract(1, 'y').startOf('month'), moment(), 'd', '[]')) {
          const stateByDay = getValueByDay(statesByMonth, dayDate);
          const stateDistributionByDay = getDistributionByDay(stateByDay, lastState, dayDate.format('DD/MM/YYYY'));
          lastState = stateDistributionByDay.lastState;
          globalState.push(stateDistributionByDay);
        } else {
          globalState.push({ name: i + 1 });
        }

      }
    }

    return globalState;
  };
  const statesByYear = (datas, start, end) => {
    const statesByYear = [];
    const monthBoundary = { start: false, end: false };
    let globalState = [];

    // Récupération des états bornes et des valeurs du mois en cours
    for (let i = 0; i < datas.length; i++) {
      if (!moment(datas[i].dateEtat).isBefore(start) && monthBoundary.start === false) {
        datas[i - 1] ? statesByYear.push(datas[i - 1]) : null;
        monthBoundary.start = true;
      }
      if (moment(datas[i].dateEtat).isBetween(start, end, 's', '[]')) {
        statesByYear.push(datas[i]);
      }
      if (moment(datas[i].dateEtat).isAfter(end) && monthBoundary.end === false) {
        statesByYear.push(datas[i]);
        monthBoundary.end = true;
      }
    }

    // Génération des proportions pour l'ensemble des jours du mois
    if (statesByYear && statesByYear.length > 0) {
      let lastState = statesByYear[0].etat;

      for (let i = 0; i < moment.monthsShort().length; i++) {
        const dayDate = moment(`${lpad(i + 1, '0', 2)}-01-${start.format('YYYY')}`, 'MM-DD-YYYY');

        // Création des valeurs du graphe pour la journée donnée si elle se trouve sur l'interval
        if (dayDate.isBetween(moment().subtract(1, 'y').startOf('month'), moment(), 'd', '[]')) {

          const stateByMonth = getValueByMonth(statesByYear, dayDate);
          const stateDistributionByMonth = getDistributionByMonth(stateByMonth, lastState, moment.monthsShort()[i][0].toUpperCase() + moment.monthsShort()[i].slice(1), dayDate);

          lastState = stateDistributionByMonth.lastState;
          globalState.push(stateDistributionByMonth);

        } else {
          globalState.push({ name: moment.monthsShort()[i] });
        }

      }
    }

    return globalState;
  };
  const getValueByDay = (values, day) => {
    const datas = [];

    for (const v of values) {
      if (moment(v.dateEtat).isSame(day, 'd')) {
        datas.push(v);
      }
    }

    return datas;
  };
  const getValueByMonth = (values, day) => {
    const datas = [];

    for (const v of values) {
      if (moment(v.dateEtat).isSame(day, 'M')) {
        datas.push(v);
      }
    }

    return datas;
  };
  const getDistributionByDay = (states, lastState, nbDay) => {
    const distribution = { name: nbDay, '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, lastState: lastState, time: 0 };

    // Remplissage de la distribution
    if (states.length === 0) {
      return {
        name: nbDay,
        [lastState]: 100,
        lastState: lastState,
      };
    } else {

      // Calcul de la proportion de chaque statut sur la journée
      for (const s of states) {
        const m = moment(s.dateEtat);
        const newSwitchState = (m.hour() * 60) + m.minute();
        const diffTime = newSwitchState - distribution.time;
        distribution[distribution.lastState] = distribution[distribution.lastState] + diffTime;
        distribution.lastState = s.etat;
        distribution.time = (m.hour() * 60) + m.minute();
      }

      // Remplissage des heures manquantes
      const totalTime = distribution['0'] + distribution['1'] + distribution['2'] + distribution['3'] + distribution['4'] + distribution['5'];
      distribution[distribution.lastState] = distribution[distribution.lastState] + (1440 - totalTime);

      // Remplacement des valeurs en minutes par des pourcentages dans la répartition par statut
      for (let i = 0; i < 6; i++) {
        distribution[i] = Math.round(((100 * distribution[i]) / 1440) * 100) / 100;
      }

      return distribution;
    }
  };
  const getDistributionByMonth = (states, lastState, month, startMonthDate) => {
    const distribution = { name: month, '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, lastState: lastState, time: startMonthDate.unix() };
    const endMonthDate = moment(startMonthDate).endOf('month');
    const monthDuration = endMonthDate.diff(startMonthDate, 's');

    // Remplissage de la distribution
    if (states.length === 0) {
      return {
        name: month,
        [lastState]: 100,
        lastState: lastState,
      };
    } else {

      // Calcul de la proportion de chaque statut sur la journée
      for (const s of states) {
        const m = moment(s.dateEtat);
        const diffTime = m.unix() - distribution.time;
        distribution[distribution.lastState] = distribution[distribution.lastState] + diffTime;
        distribution.lastState = s.etat;
        distribution.time = m.unix();
      }

      // Remplissage des heures manquantes
      const totalTime = distribution['0'] + distribution['1'] + distribution['2'] + distribution['3'] + distribution['4'] + distribution['5'];
      distribution[distribution.lastState] = distribution[distribution.lastState] + (monthDuration - totalTime);

      // Remplacement des valeurs en minutes par des pourcentages dans la répartition par statut
      for (let i = 0; i < 6; i++) {
        distribution[i] = Math.round(((100 * distribution[i]) / monthDuration) * 100) / 100;
      }

      return distribution;
    }
  };
  const handleSwitchGraphMode = () => {
    if (displayMode === 'year') {
      setDisplayMode('month');
    } else {
      setDisplayMode('year');
    }
    setDateFromGraph(null);
  }
  const showMonthDetail = (e) => {
    if (displayMode === 'year' && (e?.activeTooltipIndex >= 0 && e?.activeTooltipIndex <= 11)) {
      const selectedDate = moment(`${lpad(e.activeTooltipIndex + 1, '0', 2)}-01-${graphDate.year()}`, 'MM-DD-YYYY');
      if (selectedDate.isBetween(borneMin, borneMax, 'd', '[]')) {
        setDisplayMode('month');
        setGraphDate(selectedDate);
      }
    }
    if (displayMode === 'month' && e?.activeLabel && moment(e?.activeLabel, 'DD/MM/YYYY').isValid) {
      setDateFromGraph(moment(e.activeLabel, 'DD/MM/YYYY'));
    }
  }
  const removeAlarmFilter = () => {
    setDateFromGraph(null);
  }

  if (isMobile) {
    return (
      <TabPanel className={classes.tabPanel} value={value} index={2}>
        <div className="row" style={{ flexDirection: 'column', borderBottom: '2px solid #E4E8EC', paddingBottom: '10px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '2.5vw', margin: '8px 0 20px 0' }}>
            Etat fonctionnement
            <FormControlLabel
              control={<Switch checked={displayMode === 'year' ? true : false} onChange={handleSwitchGraphMode} />}
              label={displayMode === 'year' ? "Mode Annuel" : "Mode Mensuel"}
              style={{ marginLeft: '15px' }}
            />
          </div>

          {
            displayMode === 'year' &&
            <GraphDateSelector libelle={graphDate ? graphDate.format('YYYY') : ''} handlePreviousMonth={handlePreviousMonth} handleNextMonth={handleNextMonth} />
          }
          {
            displayMode === 'month' &&
            <GraphDateSelector libelle={graphDate ? graphDate.format('MMM YYYY') : ''} handlePreviousMonth={handlePreviousMonth} handleNextMonth={handleNextMonth} />
          }

          <BarChart width={width} height={300} data={graphDatas} margin={{ top: 20, right: 20, left: 0, bottom: 5, }} onClick={(e) => showMonthDetail(e)}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis domain={[0, 100]} allowDataOverflow={false} tick={false} />
            <Tooltip cursor={{ fill: 'rgba(220,225,230,0.75)' }} />
            <Legend verticalAlign="bottom" margin={{ top: 20, left: 0, right: 0, bottom: 0 }} />
            <Bar dataKey="1" name="Disponible" stackId="a" fill="#97C21E" />
            <Bar dataKey="2" name="Disponible avec alarme" stackId="a" fill="#008DAA" />
            <Bar dataKey="3" name="Dégradé" stackId="a" fill="#F28A00" />
            <Bar dataKey="4" name="Indisponible" stackId="a" fill="#AB1054" />
            <Bar dataKey="5" name="Hors exploitation" stackId="a" fill="#5D6770" />
          </BarChart>

        </div>

        <div className="row" style={{ flexDirection: 'column', borderBottom: '2px solid #E4E8EC', paddingBottom: '10px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '2.5vw', margin: '8px 0 20px 0' }}>
            {dateFromGraph ? `alarmes du ${dateFromGraph.format('DD/MM/YYYY')}` : ''}
            {
              dateFromGraph &&
              <div onClick={removeAlarmFilter}><i className="cell-render-icon-circle-background fas fa-times" /></div>
            }
          </div>
          <div className="display-alarmes-equipement">
            {
              filterAlarmes.map((a) => {
                return (
                  <Card key={'paper-alarm-' + a.id} className={classes.cardAlarm}>
                    <div className="row">
                      <div style={{ width: '50%' }}>
                        <KeyValue title="code type" value={a['typeAlarmeCode']} />
                        <KeyValue title="id soc." value={a['equipementIdSociete']} />
                        <KeyValue title="date déb." value={a['dateDeb'] ? moment(a['dateDeb']).format('DD/MM/YYYY à HH:mm') : '-'} />
                        <KeyValue title="état acq." value={a['acquitEtat'] ? 'ACQ.' : 'NON ACQ.'} />
                        <KeyValue title="motif acq." value={a['acquitMotifLibelle'] ? a['acquitMotifLibelle'] : '-'} />
                      </div>
                      <div style={{ width: '50%' }}>
                        <KeyValue title="libellé type" value={a['typeAlarmeLibelle']} />
                        <KeyValue title="topo." value={a['equipementToponyme']} />
                        <KeyValue title="date fin" value={a['dateFin'] ? moment(a['dateFin']).format('DD/MM/YYYY à HH:mm') : '-'} />
                        <KeyValue title="date acq." value={a['acquitDate'] ? moment(a['acquitDate']).format('DD/MM/YYYY à HH:mm') : '-'} />
                      </div>
                    </div>
                  </Card>
                );
              })
            }
          </div>
        </div>
      </TabPanel>
    );
  }

  return (
    <TabPanel className={classes.tabPanel} value={value} index={2} style={{ width: '100%' }}>
      <div className="overflow-auto" style={{ overflow: 'auto', height: 'calc(90vh - 145px)' }}>

        <div className="row" style={{ flexDirection: 'column' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '1vw' }}>
            Etat de fonctionnement
            <FormControlLabel
              control={<Switch checked={displayMode === 'year' ? true : false} onChange={handleSwitchGraphMode} />}
              label={displayMode === 'year' ? "Mode Annuel" : "Mode Mensuel"}
              style={{ marginLeft: '15px' }}
            />
          </div>

          {
            displayMode === 'year' &&
            <GraphDateSelector libelle={graphDate ? graphDate.format('YYYY') : ''} handlePreviousMonth={handlePreviousMonth} handleNextMonth={handleNextMonth} />
          }
          {
            displayMode === 'month' &&
            <GraphDateSelector libelle={graphDate ? graphDate.format('MMM YYYY') : ''} handlePreviousMonth={handlePreviousMonth} handleNextMonth={handleNextMonth} />
          }

          <BarChart width={width - 250} height={300} data={graphDatas} margin={{ top: 20, right: 0, left: 0, bottom: 5, }} onClick={(e) => showMonthDetail(e)}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis domain={[0, 100]} allowDataOverflow={false} tick={false} />
            <Tooltip cursor={{ fill: 'rgba(220,225,230,0.75)' }} />
            <Legend verticalAlign="bottom" margin={{ top: 20, left: 0, right: 0, bottom: 0 }} />
            <Bar dataKey="1" name="Disponible" stackId="a" fill="#97C21E" />
            <Bar dataKey="2" name="Disponible avec alarme" stackId="a" fill="#008DAA" />
            <Bar dataKey="3" name="Dégradé" stackId="a" fill="#F28A00" />
            <Bar dataKey="4" name="Indisponible" stackId="a" fill="#AB1054" />
            <Bar dataKey="5" name="Hors exploitation" stackId="a" fill="#5D6770" />
          </BarChart>

        </div>

        <div className="row" style={{ flexDirection: 'column' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '1vw' }}>
            {dateFromGraph ? `alarmes du ${dateFromGraph.format('DD/MM/YYYY')}` : ''}
            {
              dateFromGraph &&
              <div onClick={removeAlarmFilter}><i className="cell-render-icon-circle-background fas fa-times" /></div>
            }
          </div>
          {
            dateFromGraph &&
            <BasicTab
              width={'100%'}
              headers={['date apparition', 'date disparition', 'acquittée', 'date acq.', 'motif acq.', 'équipement', 'toponyme', 'type']}
              columns={['dateDeb', 'dateFin', 'acquitEtat', 'acquitDate', 'acquitMotifLibelle', 'equipementIdSociete', 'equipementToponyme', 'typeAlarmeLibelle']}
              datas={filterAlarmes}
              style={{
                header: {
                  row: {
                    backgroundColor: '#F0F3F6',
                    fontSize: width > 1400 ? '0.75vw' : '1vw',
                  },
                },
                datas: {
                  row: {
                    borderBottom: '1px solid #EBEEF1',
                    fontSize: width > 1400 ? '0.75vw' : '1vw',
                  },
                },
              }}
              auth={auth}
            />
          }
        </div>
      </div>
    </TabPanel>
  );

};

export default OngletAlarme;